var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviewIcon = function SvgPreviewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m8.5 8.5 5 5"
  }))));
};
export default SvgPreviewIcon;